unit View.Gerenciar.Usuario;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, App.Types, View.Dialog, WEBLib.WebTools,
  XData.Web.Client, ConnectionModule, Auth.Service, UUtils, UWeb.Enum;

type
  TFViewGerenciarUsuario = class(TForm)
    lblTituloPagina: TLabel;
    edtNovaSenha: TEdit;
    btnContinuar: TButton;
    edtConfirmarSenha: TEdit;
    XDataClientGerenciarUsuario: TXDataWebClient;
    lbLogando: TLabel;
    imgLogando: TImageControl;
    lbMessage: TLabel;
    imgLogin: TImageControl;
    procedure WebFormShow(Sender: TObject);
    procedure btnContinuarClick(Sender: TObject);
    procedure edtNovaSenhaClick(Sender: TObject);
    procedure edtConfirmarSenhaClick(Sender: TObject);
    procedure XDataClientGerenciarUsuarioError(Error: TXDataClientError);
    procedure XDataClientGerenciarUsuarioLoad(Response: TXDataClientResponse);
    procedure WebFormCreate(Sender: TObject);
  private
    procedure Processar;
    function ValidarDados : Boolean;
    procedure MostrarOcultarAguarde(pMostrar : Boolean);
    procedure ShowNotification(pNotification: string);
  public
   class procedure Display(AElementId: string; LoginProc: TSuccessProc); overload;
    class procedure Display(AElementId: string; LoginProc: TSuccessProc;
      AMsg: string); overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewGerenciarUsuario: TFViewGerenciarUsuario;

implementation

{$R *.dfm}

{ TFViewGerenciarUsuario }

class procedure TFViewGerenciarUsuario.Display(AElementId: string;
  LoginProc: TSuccessProc; AMsg: string);

  procedure AfterCreate(AForm: TObject);
  begin
    //
  end;

begin
  if Assigned(FViewGerenciarUsuario) then
    FViewGerenciarUsuario.Free;
  FViewGerenciarUsuario := TFViewGerenciarUsuario.CreateNew(AElementId, @AfterCreate);
end;

procedure TFViewGerenciarUsuario.btnContinuarClick(Sender: TObject);
begin
  lbMessage.Visible := False;

  if not ValidarDados then
  begin
    MostrarOcultarAguarde(False);
    Exit;
  end;

  MostrarOcultarAguarde(True);

  Processar;
end;

class procedure TFViewGerenciarUsuario.Display(AElementId: string;
  LoginProc: TSuccessProc);
begin
  TFViewGerenciarUsuario.Display(AElementId, LoginProc, '');
end;

procedure TFViewGerenciarUsuario.edtConfirmarSenhaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_gerenciar_form_lbconfirarsenha');
end;

procedure TFViewGerenciarUsuario.edtNovaSenhaClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_gerenciar_form_lbnovasenha');
end;

procedure TFViewGerenciarUsuario.MostrarOcultarAguarde(pMostrar: Boolean);
begin
  btnContinuar.Enabled := not pMostrar;
  lbLogando.Visible := pMostrar;
  imgLogando.Visible := pMostrar;
end;

procedure TFViewGerenciarUsuario.Processar;
var
  lJson : TJSObject;
begin
  lJson := TJSObject.New;
  lJson['codigo'] := Copy(Application.hash, Pos('codigo_hash=', Application.hash) + Length('codigo_hash='), MaxInt);

  if Pos('ativacao-de-cadastro', Application.hash) > 0 then
    lJson['acao'] := 'ativar_cadastro'
  else
    lJson['acao'] := 'atualizar_senha';

  lJson['senha'] := edtNovaSenha.Text;

  XDataClientGerenciarUsuario.RawInvoke('ILoginService.GerenciarUsuario', [lJson]);
end;

procedure TFViewGerenciarUsuario.ShowNotification(pNotification: string);
begin
  if pNotification <> '' then
  begin
    lbMessage.Visible := True;
    lbMessage.Caption := pNotification;
  end;
end;


function TFViewGerenciarUsuario.ValidarDados : Boolean;
begin
  Result := False;

  if Trim(edtNovaSenha.Text) = '' then
  begin
    ShowNotification('Digite a nova senha');

    Exit;
  end
  else if Length(Trim(edtNovaSenha.Text)) < 6 then
  begin
    ShowNotification('Senha deve ter no mínimo 6 caracteres');

    Exit;
  end
  else if Trim(edtConfirmarSenha.Text) = '' then
  begin
    ShowNotification('Digite a senha de confirmação');

    Exit;
  end
  else if edtConfirmarSenha.Text <> edtNovaSenha.Text then
  begin
    ShowNotification('Senhas se diferem!');

    Exit;
  end
  else if not ((Pos('ativacao-de-cadastro', Application.hash) > 0) or (Pos('recuperar-senha', Application.hash) > 0)) then
  begin
    ShowNotification('Url inválida');
    Exit;
  end
  else if Pos('codigo_hash', Application.hash) <= 0 then
  begin
    ShowNotification('Código hash inválido');
    Exit;
  end;

  Result := True;
end;

procedure TFViewGerenciarUsuario.WebFormCreate(Sender: TObject);
begin
  if DMConnection.FServidor = TServidor.SERVICE then
    imgLogin.url := 'assets/img/logo-facil.svg'
  else if DMConnection.FServidor = TServidor.WHATSAPP then
    imgLogin.url := 'assets/img/img_login.png';

  MostrarOcultarAguarde(False);
  lbMessage.Visible := False;
end;

procedure TFViewGerenciarUsuario.WebFormShow(Sender: TObject);
begin
  if (Pos('recuperar-senha', Application.hash) > 0) then
  begin
    lblTituloPagina.Caption := 'Digite a senha para atualizar o cadastro';
  end;
end;

procedure TFViewGerenciarUsuario.XDataClientGerenciarUsuarioError(
  Error: TXDataClientError);
begin
  MostrarOcultarAguarde(False);

  if Pos('código hash', LowerCase(Error.ErrorMessage)) > 0 then
    ShowNotification('Código de ativação inválido/expirado! Solicite o reenvio ao suporte.')
  else
    ShowNotification(Error.ErrorMessage);
end;

procedure TFViewGerenciarUsuario.XDataClientGerenciarUsuarioLoad(
  Response: TXDataClientResponse);
begin
  MostrarOcultarAguarde(False);
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!#recarregar_pagina_principal#');
  AuthService.Logout;
end;

procedure TFViewGerenciarUsuario.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblTituloPagina := TLabel.Create('lblTituloPagina');
  lbLogando := TLabel.Create('label_aguardando');
  imgLogando := TImageControl.Create('gif-carregando');
  lbMessage := TLabel.Create('view.login.message.label');
  imgLogin := TImageControl.Create('imgLogin');
  edtNovaSenha := TEdit.Create('edtNovaSenha');
  btnContinuar := TButton.Create('btnContinuar');
  edtConfirmarSenha := TEdit.Create('edtConfirmarSenha');
  XDataClientGerenciarUsuario := TXDataWebClient.Create(Self);

  lblTituloPagina.BeforeLoadDFMValues;
  lbLogando.BeforeLoadDFMValues;
  imgLogando.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  imgLogin.BeforeLoadDFMValues;
  edtNovaSenha.BeforeLoadDFMValues;
  btnContinuar.BeforeLoadDFMValues;
  edtConfirmarSenha.BeforeLoadDFMValues;
  XDataClientGerenciarUsuario.BeforeLoadDFMValues;
  try
    Name := 'FViewGerenciarUsuario';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblTituloPagina.SetParentComponent(Self);
    lblTituloPagina.Name := 'lblTituloPagina';
    lblTituloPagina.Left := 224;
    lblTituloPagina.Top := 104;
    lblTituloPagina.Width := 198;
    lblTituloPagina.Height := 15;
    lblTituloPagina.Caption := 'Crie uma senha para ativar o cadastro';
    lblTituloPagina.HeightPercent := 100.000000000000000000;
    lblTituloPagina.Transparent := False;
    lblTituloPagina.WidthPercent := 100.000000000000000000;
    lbLogando.SetParentComponent(Self);
    lbLogando.Name := 'lbLogando';
    lbLogando.Left := 24;
    lbLogando.Top := 288;
    lbLogando.Width := 45;
    lbLogando.Height := 15;
    lbLogando.Caption := 'Aguarde';
    lbLogando.HeightPercent := 100.000000000000000000;
    lbLogando.WidthPercent := 100.000000000000000000;
    imgLogando.SetParentComponent(Self);
    imgLogando.Name := 'imgLogando';
    imgLogando.Left := 24;
    imgLogando.Top := 307;
    imgLogando.Width := 100;
    imgLogando.Height := 41;
    imgLogando.HeightPercent := 100.000000000000000000;
    imgLogando.WidthPercent := 100.000000000000000000;
    imgLogando.ChildOrder := 6;
    lbMessage.SetParentComponent(Self);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 280;
    lbMessage.Top := 221;
    lbMessage.Width := 3;
    lbMessage.Height := 15;
    lbMessage.HeightPercent := 100.000000000000000000;
    lbMessage.WidthPercent := 100.000000000000000000;
    imgLogin.SetParentComponent(Self);
    imgLogin.Name := 'imgLogin';
    imgLogin.Left := 24;
    imgLogin.Top := 112;
    imgLogin.Width := 100;
    imgLogin.Height := 41;
    imgLogin.HeightPercent := 100.000000000000000000;
    imgLogin.WidthPercent := 100.000000000000000000;
    imgLogin.ChildOrder := 11;
    edtNovaSenha.SetParentComponent(Self);
    edtNovaSenha.Name := 'edtNovaSenha';
    edtNovaSenha.Left := 240;
    edtNovaSenha.Top := 136;
    edtNovaSenha.Width := 121;
    edtNovaSenha.Height := 21;
    edtNovaSenha.ChildOrder := 5;
    edtNovaSenha.HeightPercent := 100.000000000000000000;
    edtNovaSenha.TextHint := 'Digite sua nova senha';
    edtNovaSenha.WidthPercent := 100.000000000000000000;
    SetEvent(edtNovaSenha, Self, 'OnClick', 'edtNovaSenhaClick');
    btnContinuar.SetParentComponent(Self);
    btnContinuar.Name := 'btnContinuar';
    btnContinuar.Left := 240;
    btnContinuar.Top := 254;
    btnContinuar.Width := 121;
    btnContinuar.Height := 25;
    btnContinuar.Caption := 'Continuar';
    btnContinuar.ChildOrder := 7;
    btnContinuar.HeightPercent := 100.000000000000000000;
    btnContinuar.TabOrder := 2;
    btnContinuar.WidthPercent := 100.000000000000000000;
    SetEvent(btnContinuar, Self, 'OnClick', 'btnContinuarClick');
    edtConfirmarSenha.SetParentComponent(Self);
    edtConfirmarSenha.Name := 'edtConfirmarSenha';
    edtConfirmarSenha.Left := 240;
    edtConfirmarSenha.Top := 176;
    edtConfirmarSenha.Width := 121;
    edtConfirmarSenha.Height := 21;
    edtConfirmarSenha.ChildOrder := 5;
    edtConfirmarSenha.HeightPercent := 100.000000000000000000;
    edtConfirmarSenha.TabOrder := 1;
    edtConfirmarSenha.TextHint := 'Confirmar Senha';
    edtConfirmarSenha.WidthPercent := 100.000000000000000000;
    SetEvent(edtConfirmarSenha, Self, 'OnClick', 'edtConfirmarSenhaClick');
    XDataClientGerenciarUsuario.SetParentComponent(Self);
    XDataClientGerenciarUsuario.Name := 'XDataClientGerenciarUsuario';
    XDataClientGerenciarUsuario.Connection := DMConnection.AuthConnection;
    SetEvent(XDataClientGerenciarUsuario, Self, 'OnLoad', 'XDataClientGerenciarUsuarioLoad');
    SetEvent(XDataClientGerenciarUsuario, Self, 'OnError', 'XDataClientGerenciarUsuarioError');
    XDataClientGerenciarUsuario.Left := 360;
    XDataClientGerenciarUsuario.Top := 392;
  finally
    lblTituloPagina.AfterLoadDFMValues;
    lbLogando.AfterLoadDFMValues;
    imgLogando.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    imgLogin.AfterLoadDFMValues;
    edtNovaSenha.AfterLoadDFMValues;
    btnContinuar.AfterLoadDFMValues;
    edtConfirmarSenha.AfterLoadDFMValues;
    XDataClientGerenciarUsuario.AfterLoadDFMValues;
  end;
end;

end.